import React, { useEffect, useRef } from "react";

import styles from "./BeaconMap.scss";

const BeaconPulse = () => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    const animation = el.animate(
      [
        { opacity: 1, transform: "scale(1)" },
        { opacity: 0, transform: "scale(2.5)" },
      ],
      { duration: 1500, iterations: Infinity, easing: "ease-out" }
    );

    return () => animation.cancel();
  }, []);

  return <div ref={ref} className={styles.beaconPulse} />;
};

export default BeaconPulse;
